import React, { Component } from 'react';
import { Divider, Grid } from 'semantic-ui-react';
import { Footer } from '../styles';
import Contact from './Contact';
import styled from 'styled-components';

const { Column } = Grid;

const Img = styled.img`
  margin-left: 0;
`;

class MFooterHomely extends Component {
  render() {
    const { getTranslation } = this.props;
    const { body } = getTranslation('RESET_PASSWORD_PARTNER_LOGO') || {
      body: '',
      variables: undefined,
    };
    return (
      <Footer background="#0f6f5c">
        <Img src={body} alt="partner_logo" width="170px" height="43px" />
        <Divider />
        <Column>
          <Contact getTranslation={(messageCode) => getTranslation(messageCode)} />
        </Column>
      </Footer>
    );
  }
}

export default MFooterHomely;
